<template>
    <div v-if="browserTrue.status">
        <slot />
    </div>
    <div class="invalidBrowser" v-else>{{browserTrue.message}}</div>

<!--    <a target="_blank" title="Click here to chat" class="customer-chat" href="/user-chat">-->
<!--        <img src="#" alt="">-->
<!--    </a>-->

</template>

<script>

export default {
        name: 'LayoutAuth',
        data() {
            return {
                browserTrue: {status: true},
             }
        },
        mounted() {
            this.browserFirefox();
        },
        methods:{
            browserFirefox() {
                // DashboardService.browserFirefox().then(
                //     (response) => {

                //         this.browserTrue = response.data;
                //     }
                // );
            },
        }
    }
</script>

<style>

</style>